"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPolicyFailure = exports.createPolicySuccess = exports.createPolicyLoading = exports.createPolicyRequest = exports.getPolicyByIdReset = exports.getPolicyByIdRequest = exports.getPolicyByNameReset = exports.getPolicyByNameFailure = exports.getPolicyByNameSuccess = exports.getPolicyByNameLoading = exports.getPolicyByNameRequest = exports.recursiveClonePermissionListReset = exports.recursiveClonePermissionListFail = exports.recursiveClonePermissionListSuccess = exports.recursiveClonePermissionListLoadingDisable = exports.recursiveClonePermissionListLoading = exports.recursiveClonePermissionListRequest = exports.recursiveCloneRoleListReset = exports.recursiveCloneRoleListFail = exports.recursiveCloneRoleListSuccess = exports.recursiveCloneRoleListDisableLoading = exports.recursiveCloneRoleListLoading = exports.recursiveCloneRoleListRequest = void 0;

var _constants = require("./constants");

var recursiveCloneRoleListRequest = function recursiveCloneRoleListRequest(payload) {
  return {
    type: _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_REQUEST,
    payload: payload
  };
};

exports.recursiveCloneRoleListRequest = recursiveCloneRoleListRequest;

var recursiveCloneRoleListLoading = function recursiveCloneRoleListLoading() {
  return {
    type: _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_LOADING
  };
};

exports.recursiveCloneRoleListLoading = recursiveCloneRoleListLoading;

var recursiveCloneRoleListDisableLoading = function recursiveCloneRoleListDisableLoading() {
  return {
    type: _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_LOADING_DISABLE
  };
};

exports.recursiveCloneRoleListDisableLoading = recursiveCloneRoleListDisableLoading;

var recursiveCloneRoleListSuccess = function recursiveCloneRoleListSuccess(payload) {
  return {
    type: _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_SUCCESS,
    payload: payload
  };
};

exports.recursiveCloneRoleListSuccess = recursiveCloneRoleListSuccess;

var recursiveCloneRoleListFail = function recursiveCloneRoleListFail(payload) {
  return {
    type: _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_FAILURE,
    payload: payload
  };
};

exports.recursiveCloneRoleListFail = recursiveCloneRoleListFail;

var recursiveCloneRoleListReset = function recursiveCloneRoleListReset() {
  return {
    type: _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_RESET
  };
};

exports.recursiveCloneRoleListReset = recursiveCloneRoleListReset;

var recursiveClonePermissionListRequest = function recursiveClonePermissionListRequest(payload) {
  return {
    type: _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_REQUEST,
    payload: payload
  };
};

exports.recursiveClonePermissionListRequest = recursiveClonePermissionListRequest;

var recursiveClonePermissionListLoading = function recursiveClonePermissionListLoading() {
  return {
    type: _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING
  };
};

exports.recursiveClonePermissionListLoading = recursiveClonePermissionListLoading;

var recursiveClonePermissionListLoadingDisable = function recursiveClonePermissionListLoadingDisable() {
  return {
    type: _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING_DISABLE
  };
};

exports.recursiveClonePermissionListLoadingDisable = recursiveClonePermissionListLoadingDisable;

var recursiveClonePermissionListSuccess = function recursiveClonePermissionListSuccess(payload) {
  return {
    type: _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_SUCCESS,
    payload: payload
  };
};

exports.recursiveClonePermissionListSuccess = recursiveClonePermissionListSuccess;

var recursiveClonePermissionListFail = function recursiveClonePermissionListFail(payload) {
  return {
    type: _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_FAILURE,
    payload: payload
  };
};

exports.recursiveClonePermissionListFail = recursiveClonePermissionListFail;

var recursiveClonePermissionListReset = function recursiveClonePermissionListReset() {
  return {
    type: _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_RESET
  };
};

exports.recursiveClonePermissionListReset = recursiveClonePermissionListReset;

var getPolicyByNameRequest = function getPolicyByNameRequest(name, history, consumer, consumerEntityId, redirectPath) {
  return {
    type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_REQUEST,
    payload: {
      name: name,
      history: history,
      consumer: consumer,
      consumerEntityId: consumerEntityId,
      redirectPath: redirectPath
    }
  };
};

exports.getPolicyByNameRequest = getPolicyByNameRequest;

var getPolicyByNameLoading = function getPolicyByNameLoading() {
  return {
    type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_LOADING
  };
};

exports.getPolicyByNameLoading = getPolicyByNameLoading;

var getPolicyByNameSuccess = function getPolicyByNameSuccess(ClonePolicyData) {
  return {
    type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_SUCCESS,
    payload: ClonePolicyData
  };
};

exports.getPolicyByNameSuccess = getPolicyByNameSuccess;

var getPolicyByNameFailure = function getPolicyByNameFailure(reason) {
  return {
    type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_FAILURE,
    payload: {
      error: reason
    }
  };
};

exports.getPolicyByNameFailure = getPolicyByNameFailure;

var getPolicyByNameReset = function getPolicyByNameReset() {
  return {
    type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_RESET
  };
};

exports.getPolicyByNameReset = getPolicyByNameReset;

var getPolicyByIdRequest = function getPolicyByIdRequest(id, history, consumer, consumerEntityId, redirectPath) {
  return {
    type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_REQUEST,
    payload: {
      id: id,
      history: history,
      consumer: consumer,
      consumerEntityId: consumerEntityId,
      redirectPath: redirectPath
    }
  };
};

exports.getPolicyByIdRequest = getPolicyByIdRequest;

var getPolicyByIdReset = function getPolicyByIdReset() {
  return {
    type: _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_RESET
  };
};

exports.getPolicyByIdReset = getPolicyByIdReset;

var createPolicyRequest = function createPolicyRequest(data, history, consumer, consumerEntityId, redirectPath) {
  return {
    type: _constants.ClonePolicyType.CLONE_POLICY_REQUEST,
    payload: {
      data: data,
      history: history,
      consumer: consumer,
      consumerEntityId: consumerEntityId,
      redirectPath: redirectPath
    }
  };
};

exports.createPolicyRequest = createPolicyRequest;

var createPolicyLoading = function createPolicyLoading() {
  return {
    type: _constants.ClonePolicyType.CLONE_POLICY_LOADING
  };
};

exports.createPolicyLoading = createPolicyLoading;

var createPolicySuccess = function createPolicySuccess(response) {
  return {
    type: _constants.ClonePolicyType.CLONE_POLICY_SUCCESS,
    payload: response
  };
};

exports.createPolicySuccess = createPolicySuccess;

var createPolicyFailure = function createPolicyFailure(response) {
  var _response$data;

  return {
    type: _constants.ClonePolicyType.CLONE_POLICY_FAILURE,
    payload: response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message
  };
};

exports.createPolicyFailure = createPolicyFailure;